"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jsSearchIndex = void 0;
var js_search_1 = require("js-search");
function jsSearchIndex(suggestions) {
    var docs = suggestions.map(function (suggestion, id) {
        return {
            id: id,
            text: suggestion.segments
                .map(function (segment) { return (typeof segment === 'string' ? segment : segment.join(' ')); })
                .join(''),
        };
    });
    var search = new js_search_1.Search('id');
    search.addIndex('text');
    search.addDocuments(docs);
    return function (text) {
        if (!text)
            return [];
        var results = search.search(text);
        return results.map(function (result) { return suggestions[result.id]; });
    };
}
exports.jsSearchIndex = jsSearchIndex;
//# sourceMappingURL=jsSearchIndex.js.map